module.exports = __webpack_public_path__ + "static/darrell-jodoin-833b536374c00245b13e71791c38a6f4.jpg";